import { mapGetters } from "vuex";
import { urlExists } from "@/utils/file.util";
import workflowMixin from "@/mixins/workflow.mixin"
import monthPickerMixin from "@/mixins/monthPicker.mixin"
import { getDateFormat } from '@/utils/getDateFormat.util'
import { getDisplayStatus } from "@/mixins/displayLogic.mixin";

export default {
  mixins: [workflowMixin,monthPickerMixin],

  watch: {
    reset: {
      handler: function(newVal, oldVal) {
        if(newVal != oldVal && newVal === true) {
          this.$refs.questionForm.reset()
        }
      }
    }
  },

  props: {
    reset: {
      type: Boolean,
      default: false
    },

    currentSurveyTab: {
      type: Number,
      required: false,
    },

    previewMode: {
      type: Boolean,
      default: false,
    },

    contentHeight: {
      type: Number,
      default: 500,
    },

    formFields: {
      type: Array,
      default: () => []
    }
  },

  data() {
    return {
      canAutoSave: false,
      updateFieldAction: 'updateFormBuilderActiveFormField',
      dialog: false,
      checkAnswerCalled: false,
      defaultSurveyTab: 0,
      inputHandlerDebounce: undefined,
      formResponse: {form: this.formFields},
    };
  },

  mounted() {
    this.embeddedImageFileChecker();
    this.setDefaults()
  },

  computed: {
    ...mapGetters(['getWorkflowFieldsAll', 'getWorkflowPages', 'getStates']),

    currentTab: {
      get: function () {
        if (this.currentSurveyTab === undefined) {
          return this.defaultSurveyTab;
        } else {
          return this.currentSurveyTab;
        }
      },
      set: function (index) {
        if (this.currentSurveyTab === undefined) {
          this.defaultSurveyTab = index;
        } else {
          this.$emit("update-current-survey-tab", index);
        }
      },
    },

    pageTabs() {
      if(!this.getWorkflowFieldsAll) return [];
      return this.getWorkflowFieldsAll
        .filter(f => f?.type && f.type === 'page-break')
        .sort((a, b) => a.fieldsIndex - b.fieldsIndex)
        .map((f, i) => ({ name: f?.name ? f.name : 'Page ' + (i + 1), field: f }))
    },

    //
    // Display Logic
    //

    displayStatus() {
      return (field) => {
        return getDisplayStatus({ field, formFields: this.formFields, displayTemplate: this.displayTemplate, defaultDisplayLogic: this.defaultDisplayLogic })
      }
    },
  },

  methods: {
    fixDateFormat(value) {
      return getDateFormat(value, 'YYYY-MM-DD')
    },

    embeddedImageFileChecker() {
      Object.keys(this.getWorkflowPages).forEach((key) => {
        const embeddedImages = this.getWorkflowPages[key].filter(
            (pg) => pg.type === "embedded-image" && pg.url
        );
        embeddedImages.forEach(async (img) => {
          const urlFound = await urlExists(img.imageRefs[0].url);
          if (urlFound) {
            img.imageRefs[0]["exists"] = true;
          }
        });
      });    
    },

    // GENERAL Methods

    clickedTab(selectedTab) {
      this.currentTab = selectedTab
      this.muteVideo();
    },

    previousTab() {
      this.currentTab -= 1
      this.muteVideo();
    },

    nextTab() {
      this.currentTab += 1

      this.muteVideo();
    },

    submitForm() {
      this.checkAnswerCalled = !this.checkAnswerCalled;
    },

    inputHandler(field, event) {
      // Triggers display logic template to update after user has input something

      if (this.inputHandlerDebounce) {
        clearTimeout(this.inputHandlerDebounce);
      }

      this.inputHandlerDebounce = setTimeout(() => {
        let value = event
        if(typeof event === 'object' && event?.target)
          value = event.target.value

        const toUpdate = this.updateField(field, value)
        this.$store.dispatch(this.updateFieldAction,toUpdate)
      }, 500);
    },

    // File-Input Methods

    fileInputUpload(file, field) {
      this.inputHandler(field, file);
    },

    fileInputClear(field) {
      this.inputHandler(field, undefined);
    },
  },
}